import FakeCard from './FakeCard';
import './FakeCard.scss';

export default FakeCard;
